<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header text-black fw-bold">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>Upcoming Leave Requests</span>
                            <button type="button" data-bs-toggle="modal" data-bs-target="#hmMarkLeave" class="btn btn-sm btn-outline-theme float-end"><i class="bi bi-plus-circle pe-1"></i> Apply Leave</button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <form class="g-3 mb-3 justify-content-end d-flex ">
                                <div>
                                    <label class="form-label">Select Handyman</label>
                                    <VueSelect
                                        v-model="serverOptions.handyman_id"
                                        :items="handymanOptions"
                                        :multiple="false"
                                        :placeholder="'Select Handyman'"
                                        @onSelectOption="onSelectHandyman"
                                    ></VueSelect>
                                </div>
                                <div class="ms-2">
                                    <label class="form-label">Start Date</label>
                                    <VueDatePicker
                                        name="filter_start_date"
                                        v-model="serverOptions.start_date"
                                        :format="'dd-MM-yyyy'"
                                        :enable-time-picker="false"
                                        :display-marker="false"
                                        :clearable="false"
                                        :timezone="'UTC'"
                                        :auto-apply="true"
                                        @update:modelValue="getLeaveRequests"
                                    ></VueDatePicker>
                                </div>
                                <div class="ms-2">
                                    <label class="form-label">End Date</label>
                                    <VueDatePicker
                                        name="filter_end_date"
                                        v-model="serverOptions.end_date"
                                        :format="'dd-MM-yyyy'"
                                        :enable-time-picker="false"
                                        :display-marker="false"
                                        :clearable="false"
                                        :timezone="'UTC'"
                                        :min-date="serverOptions.start_date"
                                        :auto-apply="true"
                                        :disabled="serverOptions.start_date == null"
                                        @update:modelValue="getLeaveRequests"
                                    ></VueDatePicker>
                                </div>
                                <div class="ms-2 mt-4">
                                    <button 
                                        type="button" 
                                        class="btn btn-outline-theme" 
                                        :disabled="serverOptions.start_date == null && serverOptions.end_date == null && !serverOptions.handyman_id"
                                        @click="resetFilters"
                                    >Reset</button>
                                </div>
                            </form>
                            <Vue3EasyDataTable
                                ref="leaveTable"
                                class="leave-table"
                                v-model:server-options="serverOptions"
                                :headers="headers"
                                :items="items"
                                :loading="tableLoading"
                                :server-items-length="totalItems"
                                :server-options="serverOptions"
                                header-text-direction="left"
                                body-text-direction="left"
                                buttons-pagination
                                theme-color="#1d90ff"
                                table-class-name="hm-easy-table"
                                @update:server-options="getLeaveRequests"
                            >
                                <template #item-handyman_name="item">
                                    <span class="text-capitalize">{{ item?.user?.name || '-' }}</span>
                                </template>
                                <template #item-start_date="item">
                                    {{ item.start_date ? $dateTimeFormat(item.start_date, 'DD/MM/YYYY') : '-' }}
                                </template>
                                <template #item-status="item">
                                    <span
                                        class="text-capitalize badge rounded-pill"
                                        :class="{
                                            'bg-danger': item.status === 'rejected',
                                            'bg-success': item.status === 'approved',
                                            'bg-warning text-black': item.status === 'pending'
                                        }"
                                    >
                                        {{ item.status }}
                                    </span>
                                </template>
                                <template #item-end_date="item">
                                    {{ item.end_date ? $dateTimeFormat(item.end_date, 'DD/MM/YYYY') : '-' }}
                                </template>
                                <template #item-staff_name="item">
                                    <span class="text-capitalize">{{ item?.approved_by?.name || '-' }}</span>
                                </template>
                                <template #item-action="item">
                                    <div class="text-center">
                                        <button
                                            type="button"
                                            class="btn btn-sm"
                                            :class="{'btn-outline-theme': item.status === 'pending', 'btn-outline-success': item.status !== 'pending'}"
                                            v-text="item.status === 'pending' ? 'Approve Leave' : 'Modify Leave'"
                                            @click="displayLeaveForm(item)"
                                        ></button>
                                    </div>
                                </template>
                            </Vue3EasyDataTable>
                            <table class="table table-borderless align-middle table-striped mb-0 d-none">
                                <thead>
                                    <tr class="sticky-top">
                                        <th class="bg-theme">Handyman</th>
                                        <th class="bg-theme">Start Date</th>
                                        <th class="bg-theme">End Date</th>
                                        <th class="bg-theme">Comment</th>
                                        <th class="bg-theme">Status</th>
                                        <th class="bg-theme">Approved By</th>
                                        <th class="bg-theme text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-if="Object.keys(leaves).length > 0"
                                        v-for="(leave, index) in leaves"
                                    >
                                        <td class="text-capitalize">{{ leave?.user?.first_name }}</td>
                                        <td>{{ $dateTimeFormat(leave.start_date, 'DD-MMM-YYYY') }}</td>
                                        <td>{{ leave.end_date ? $dateTimeFormat(leave.end_date, 'DD-MMM-YYYY') : '' }}</td>
                                        <td>{{ leave.comment }}</td>
                                        <td>
                                            <span
                                                class="text-capitalize badge rounded-pill"
                                                :class="{'bg-danger': leave.status === 'rejected', 'bg-success': leave.status === 'approved', 'bg-warning text-black': leave.status === 'pending'}"
                                                v-text="leave.status"
                                            ></span>
                                        </td>
                                        <td class="text-capitalize">{{ leave.status === 'approved' ? (leave?.approved_by?.first_name) : '-' }}</td>
                                        <td class="text-center">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-theme me-2"
                                                @click="displayLeaveForm(leave)"
                                            >Update Leave</button>
                                        </td>
                                    </tr>
                                    <tr v-else-if="processing">
                                        <td colspan="7" class="text-center">Processing...</td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="7" class="text-center">No leave requests found.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Update leave status -->
        <div class="modal fade" id="updateLeave" tabindex="-1" aria-labelledby="updateLeaveLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="updateLeaveLabel">Apply Leave</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row mt-1 g-3">
                            <div class="col-md-12">
                                <label for="status" class="form-label">Leave Status</label>
                                <select class="form-select" id="status" v-model="leaveData.status">
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="order_date" class="form-label">Start Date <span class="text-danger">*</span></label>
                                <!-- <BookingDatePicker
                                    v-model="leaveDates"
                                    :format="'dd-MM-yyyy'"
                                    :time-picker="false"
                                    :display-marker="false"
                                ></BookingDatePicker> -->
                                <!-- <VueDatePicker
                                    name="date"
                                    v-model="leaveDates"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :range="(leaveData.leave_type === 'multiple_days')"
                                    :min-date="new Date()"
                                ></VueDatePicker> -->
                                <VueDatePicker
                                    name="start_date"
                                    v-model="leaveData.start_date"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :min-date="new Date()"
                                    :auto-apply="true"
                                ></VueDatePicker>
                            </div>
                            <div class="col-md-6">
                                <label for="order_date" class="form-label">End Date</label>
                                <VueDatePicker
                                    name="end_date"
                                    v-model="leaveData.end_date"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :min-date="leaveData.start_date"
                                    :auto-apply="true"
                                ></VueDatePicker>
                            </div>
                            <div class="col-md-12">
                                <label for="status" class="form-label">Status <span class="text-danger">*</span></label>
                                <textarea class="form-control" id="status" v-model="leaveData.comment" rows="3" placeholder="Enter comment"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger"  data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                        <button
                            type="button"
                            class="btn btn-theme"
                            :disabled="processing"
                            :class="{ 'disabled cursor-not-allowed': processing }"
                            v-text="(processing ? 'Processing...' : 'Save')"
                            @click="updateLeave"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import BookingDatePicker from "./BookingDatePicker";
import VueSelect from './partials/VueSelect.vue';

export default {
    name: 'LeaveRequest',
    components: {
        BookingDatePicker,
        VueSelect
    },
    data() {
        return {
            processing: false,
            leaves: [],
            leaveData: {
                leave_id: '',
                leave_type: 'one_day',
                status: '',
                admin_note: '',
                date: moment().clone().day(6).format('YYYY-MM-DD'),
                leave_range:null,
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().add(6, 'days').format('YYYY-MM-DD'),
            },
            headers: [
                {text: "Handyman", value: "handyman_name", sortable: true},
                {text: "Start Date", value: "start_date", sortable: true},
                {text: "End Date", value: "end_date", sortable: true},
                {text: "Comment", value: "comment", sortable: true},
                {text: "Status", value: "status", sortable: true},
                {text: "Approved By", value: "staff_name", sortable: true},
                {text: "Action", value: "action", sortable: false},
            ],
            items: [],
            serverOptions: {
                page: 1,
                rowsPerPage: 20,
                sortBy: 'start_date',
                sortType: 'desc',
                handyman_id: '',
                start_date: null,
                end_date: null,
            },
            tableLoading: true,
            totalItems: 0,
            handymanList: [],
        }
    },

    mounted() {
        this.getHandymanList();
        this.getLeaveRequests();

        // When modal is closed
        $('#updateLeave').on('hidden.bs.modal', function () {
            this.leaveData = {
                leave_id: '',
                leave_type: 'one_day',
                status: '',
                admin_note: '',
                date: moment().clone().day(6).format('YYYY-MM-DD'),
                leave_range:null,
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().add(6, 'days').format('YYYY-MM-DD'),
            }
        });
    },
    computed: {
        leaveDates: {
            get() {
                return this.leaveData.leave_type === 'one_day' ? this.leaveData.date : this.leaveData.leave_range;
            },
            set(value) {
                if( this.leaveData.leave_type === 'one_day') {
                    this.leaveData.date = value;
                } else {
                    this.leaveData.leave_range = value;
                }
            }
        },
        handymanOptions() {
            const options = this.handymanList.map(handyman => {
                return {
                    id: handyman.id,
                    name: handyman.full_name
                }
            });

            return [
                { id: '', name: 'Select Handyman' },
                ...options
            ];
        }
    },
    methods: {
        getHandymanList() {
            axios.post('/admin/handymans/get-handymans')
                .then(response => {
                    this.handymanList = response.data.handymans || [];
                });
        },
        getLeaveRequests() {
            this.processing = true;
            this.tableLoading = true;
            axios.post('/admin/handymans/get-leave-requests', this.serverOptions)
                .then(response => {
                    this.leaves = response.data.items;
                    this.items = response.data.items;
                    this.totalItems = response.data.totalItems;
                })
                .finally(() => {
                    this.processing = false;
                    this.tableLoading = false;
                });
        },
        displayLeaveForm(leave) {
            this.leaveData.leave_id = leave.id;
            this.leaveData.leave_type = 'one_day';
            this.leaveData.status = leave.status;
            this.leaveData.admin_note = leave.admin_note;
            this.leaveData.date = this.$moment(leave.start_date).format('YYYY-MM-DD');
            this.leaveData.start_date = this.$moment(leave.start_date).format('YYYY-MM-DD');
            
            // Default set start date into the end date
            this.leaveData.end_date = this.$moment(leave.start_date).format('YYYY-MM-DD');

            // Check if end date is available
            if (leave.end_date) {
                this.leaveData.end_date = this.$moment(leave.end_date).format('YYYY-MM-DD');
                this.leaveData.leave_type = 'multiple_days';
                this.leaveData.leave_range = [this.$moment(leave.start_date).format('YYYY-MM-DD'), this.$moment(leave.end_date).format('YYYY-MM-DD')];
            }
            $('#updateLeave').modal('show');
        },
        updateLeave() {
            let self = this;
            this.processing = true;
            axios.post('/admin/handymans/update-leave-status', this.leaveData)
                .then(response => {
                    if (response.data.status === 'success') {
                        self.$notification('success', response.data.message);

                        // Iterate over leaves and update the status
                        self.leaves.forEach((leave, index) => {
                            if (leave.id === self.leaveData.leave_id) {
                                self.leaves[index].start_date = self.leaveData.start_date;
                                self.leaves[index].end_date = self.leaveData.end_date;
                                self.leaves[index].status = self.leaveData.status;
                                self.leaves[index].admin_note = self.leaveData.admin_note;
                            }
                        });

                        // Hide the modal
                        $('#updateLeave').modal('hide');

                        // Trigger the event to display the leave slider
                        self.$emitter.emit("getUnavailableHandymansOrdersEvent");

                        // Reload the leave requests
                        self.getLeaveRequests();
                    }
                })
                .catch(error => {
                    self.processing = false;
                    self.$notification('error', error.response.data.message);
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        onSelectHandyman() {
            this.getLeaveRequests();
        },
        resetFilters() {
            this.serverOptions.handyman_id = '';
            this.serverOptions.start_date = null;
            this.serverOptions.end_date = null;
            this.getLeaveRequests();
        }
    }
}
</script>
<style scoped>
/* Center only the Action column (adjust nth-child number) */
.leave-table :deep(th:last-child span),
.leave-table :deep(td:last-child) {
  text-align: center !important;
  justify-content: center !important;
}
</style>